var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chat-user',{attrs:{"member":_vm.source.member,"id":_vm.source.convId,"last-message":_vm.source.lastMessage}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-287b1ba1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/shared/ChatUserWrapper.vue
// module id = null
// module chunks = 